var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-outer-wrap"},[_c('router-view',{attrs:{"layout":_vm.layout}}),_c('menu-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }